import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { HashRouter } from "react-router-dom"
import store from './app-context/store'
import { Provider } from 'react-redux'
// import { UserContextProvider } from './app-context/user-context-provider'

// SCRUM-1118: error tracking. DSN + environment come from the runtime config.json
// (server-managed per environment; the deploy excludes it via robocopy /XF config.json).
// Blank/missing DSN => Sentry stays disabled (e.g. local dev), no errors.
async function initSentry() {
  try {
    const res = await fetch('/config.json');
    const config = await res.json();
    if (config?.sentryDsn) {
      Sentry.init({
        dsn: config.sentryDsn,
        environment: config.sentryEnv ?? 'unknown',
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 0.2, // 20% perf traces; tune later
      });
    }
  } catch {
    // config.json missing/unreadable => skip Sentry, never block app startup.
  }
}

function renderApp() {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
        <Provider store={store}>
          <HashRouter>
            <App />
          </HashRouter>
        </Provider>
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  );
}

// Initialize Sentry first so early errors are captured, then render regardless of the result.
initSentry().finally(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
